export function delegatedHTTPRoutingDefaults() {
    return {
        filterProtocols: ['unknown', 'transport-bitswap', 'transport-ipfs-gateway-http'],
        filterAddrs: ['https', 'webtransport', 'webrtc', 'webrtc-direct', 'wss', 'tls']
    };
}
//# sourceMappingURL=delegated-http-routing-defaults.browser.js.map